export default __webpack_public_path__ + "static/media/button-hover-shape.f2ab9dd7.svg";